import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit"

interface IInitialState {
    OrderTranslation: any,
    UserTranslation: any,
    OverviewTranslation: any,
    CreateOrderTranslation: any,
    OrderDetailsTranslation: any
}

const initialState: IInitialState = {
    OrderTranslation: {},
    UserTranslation: {},
    OverviewTranslation: {},
    CreateOrderTranslation: {},
    OrderDetailsTranslation: {}
}


export const TranslationSlice = createSlice({
    name: "API",
    initialState,
    reducers: {
        changeOrderTranslationValue: (state, action: PayloadAction<any | ((prev: Draft<any>) => any)>) => {
            typeof action.payload === "function"
                ? state.OrderTranslation = (action.payload as (prev: any) => any)(state.OrderTranslation)
                : state.OrderTranslation = action.payload
        },
        changeUserTranslationValue: (state, action: PayloadAction<any | ((prev: Draft<any>) => any)>) => {
            typeof action.payload === "function"
                ? state.UserTranslation = (action.payload as (prev: any) => any)(state.UserTranslation)
                : state.UserTranslation = action.payload
        },
        changeOverviewTranslationValue: (state, action: PayloadAction<any | ((prev: Draft<any>) => any)>) => {
            typeof action.payload === "function"
                ? state.OverviewTranslation = (action.payload as (prev: any) => any)(state.OverviewTranslation)
                : state.OverviewTranslation = action.payload
        },
        changeCreateOrderTranslationValue: (state, action: PayloadAction<any | ((prev: Draft<any>) => any)>) => {
            typeof action.payload === "function"
                ? state.CreateOrderTranslation = (action.payload as (prev: any) => any)(state.CreateOrderTranslation)
                : state.CreateOrderTranslation = action.payload
        },
        changeOrderDetailsTranslationValue: (state, action: PayloadAction<any | ((prev: Draft<any>) => any)>) => {
            typeof action.payload === "function"
                ? state.OrderDetailsTranslation = (action.payload as (prev: any) => any)(state.OrderDetailsTranslation)
                : state.OrderDetailsTranslation = action.payload
        },
    }
})

export const {
    changeOrderTranslationValue,
    changeUserTranslationValue,
    changeOverviewTranslationValue,
    changeCreateOrderTranslationValue,
    changeOrderDetailsTranslationValue,
} = TranslationSlice.actions

export default TranslationSlice.reducer